import { render, staticRenderFns } from "./ScrollTableCom.vue?vue&type=template&id=635d8b6e&scoped=true"
import script from "./ScrollTableCom.vue?vue&type=script&lang=js"
export * from "./ScrollTableCom.vue?vue&type=script&lang=js"
import style0 from "./ScrollTableCom.vue?vue&type=style&index=0&id=635d8b6e&prod&lang=less&scoped=true"
import style1 from "./ScrollTableCom.vue?vue&type=style&index=1&id=635d8b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d8b6e",
  null
  
)

export default component.exports